import { Controller } from "react-hook-form";
import { Input } from "rsuite";
import { commonFormProps } from "../../../utils/typeDefs";
import { useEffect, useRef } from "react";

type TranslationTitleProps = commonFormProps & {
  setIsTranslationLanguage: (value: boolean) => void;
  isTranslationFile: boolean;
  isTransitionLanguage: boolean;
};

const InputTranslationTitle = ({
  title,
  inputName,
  errors,
  control,
  inputErrorMessage,
  defaultInput,
  placeholder,
  rules,
  setIsTranslationLanguage,
  isTranslationFile,
  isTransitionLanguage
}: TranslationTitleProps) => {
  useEffect(() => {}, [isTransitionLanguage, isTranslationFile]);
  const prevValueRef = useRef(defaultInput);
  return (
    <div className="row pb-2 form-input-field">
      <div className="col-12 col-md-3 my-auto">
        <p className="form-label">
          {title}: {isTranslationFile && !isTransitionLanguage && inputErrorMessage("Required")}
        </p>
      </div>
      <div className="col-12 col-md-9">
        <Controller
          name={inputName}
          control={control}
          rules={rules}
          render={({ field }) => (
            <Input
              value={field.value}
              onChange={(value) => {
                field.onChange(value);
                if (setIsTranslationLanguage) {
                  const prevValue = prevValueRef.current;
                  const isNowEmpty = value === "";
                  const wasEmpty = prevValue === "" || prevValue === null;

                  if (isNowEmpty !== wasEmpty) {
                    setIsTranslationLanguage(!isNowEmpty);
                  }

                  prevValueRef.current = value;
                  
                }
                
              }}
              inputRef={field.ref}
              placeholder={placeholder}
            />
          )}
          defaultValue={defaultInput}
        />
      </div>
    </div>
  );
};

export default InputTranslationTitle;
